import React from 'react';

import { palette } from '../../theme';
import { Text } from '../Typography';

interface ErrorTextProps {
  children: React.ReactNode;
}

export function ErrorText({ children }: ErrorTextProps): React.ReactElement {
  return (
    <Text as="span" size={-1} color={palette.brand.red}>
      {children}
    </Text>
  );
}
